import { __extends } from "tslib";
import Resource from './resource';
import Service from '../models/service';
var ServicesModule = (function (_super) {
    __extends(ServicesModule, _super);
    function ServicesModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServicesModule.prototype.fetchList = function () {
        var _this = this;
        return this.client.http.get('/services').then(function (_a) {
            var services = _a.data.data;
            return services.map(function (service) { return new Service(service, _this.client); });
        });
    };
    ServicesModule.prototype.fetch = function (codeOrSlug) {
        var _this = this;
        return this.client.http.get("/services/" + codeOrSlug).then(function (_a) {
            var service = _a.data.data;
            return new Service(service, _this.client);
        });
    };
    ServicesModule.prototype.validateServiceAvailability = function (serviceSlug, state) {
        return this.client.http.get('/availability', { params: { serviceSlug: serviceSlug, state: state } }).then(function (_a) {
            var data = _a.data.data;
            return data;
        });
    };
    return ServicesModule;
}(Resource));
export default ServicesModule;
//# sourceMappingURL=services.js.map